export default "__VITE_ASSET__WlIH3DwF__"